<div fxLayout="row" fxLayoutWrap="wrap">
  <div fxFlex.gt-sm="100%" fxFlex="100">
    <mat-card>
      <mat-card-content>
        <mat-card-title>NUOVA PASSWORD</mat-card-title>
        <mat-card-subtitle>Inserisci la nuova password per effettuare l'accesso.</mat-card-subtitle>


        <form [formGroup]="frmInserimento">


          <mat-form-field class="full-width">
            <input matInput type="email"
                   placeholder="Email" formControlName="Email" required 
                   id="Email" />
          </mat-form-field>
          <mat-form-field class="full-width">
            <input matInput type="password"
                   placeholder="Password" formControlName="Password" required
                   id="Password" />
          </mat-form-field>

          <div class="row">
            <div fxFlex="100%;" fxFlex.xs="100%">
              <button mat-raised-button color="accent" (click)="btnNuovaPassword()">
                CREA NUOVA PASSWORD
              </button>
            </div>
          </div>




        </form>

        </mat-card-content>
</mat-card>
  </div>
</div>
